import { BlogPost } from '@/types/blog'

// 动态导入所有blog mdx文件（用于详情页渲染）
const blogModules = import.meta.glob<{ default: React.ComponentType }>('@content/blog/*.mdx', {
  eager: true,
})

// 从API获取所有blog文章
export async function getAllBlogPosts(): Promise<BlogPost[]> {
  try {
    const response = await fetch('/api/blog/posts')
    if (!response.ok) {
      throw new Error('Failed to fetch blog posts')
    }
    const posts = await response.json()
    return posts
  } catch (error) {
    console.error('Error fetching blog posts:', error)
    return []
  }
}

// 从API获取单个blog文章
export async function getBlogPostById(id: string): Promise<BlogPost | null> {
  try {
    const response = await fetch(`/api/blog/posts/${id}`)
    if (!response.ok) {
      if (response.status === 404) {
        return null
      }
      throw new Error('Failed to fetch blog post')
    }
    const post = await response.json()
    
    // 尝试获取对应的MDX组件
    const mdxComponent = getBlogPostMDXComponent(id)
    if (mdxComponent) {
      post.content = mdxComponent
    }
    
    return post
  } catch (error) {
    console.error('Error fetching blog post:', error)
    return null
  }
}

// 获取MDX组件（用于详情页渲染）
export function getBlogPostMDXComponent(id: string): React.ComponentType | null {
  // import.meta.glob返回的路径可能是多种格式，尝试匹配
  const possiblePaths = [
    `@content/blog/${id}.mdx`,
    `../content/blog/${id}.mdx`,
    `../../content/blog/${id}.mdx`,
  ]
  
  // 遍历所有可能的路径
  for (const path of possiblePaths) {
    if (blogModules[path]) {
      return blogModules[path].default
    }
  }
  
  // 如果直接路径匹配失败，尝试通过文件名匹配
  const fileName = `${id}.mdx`
  for (const [path, module] of Object.entries(blogModules)) {
    if (path.endsWith(fileName)) {
      return module.default
    }
  }
  
  return null
}
